module.exports = __webpack_public_path__ + "img/ceshi.60565b95.png";